import type { SettingsGroup } from './types';

/** Search text for a setting: title, description, group name and synonyms. */
const searchTextFor = (group: SettingsGroup, setting: SettingsGroup['settings'][number]) =>
  [group.label, group.description, setting.title, setting.description, ...(setting.keywords ?? [])]
    .filter(Boolean)
    .join(' ')
    .toLowerCase();

/** Keeps settings matching every word in `query` and drops empty groups. */
export const filterSettingsGroups = (groups: SettingsGroup[], query: string): SettingsGroup[] => {
  const terms = query.trim().toLowerCase().split(/\s+/).filter(Boolean);

  if (terms.length === 0) return groups;

  return groups
    .map((group) => ({
      ...group,
      settings: group.settings.filter((setting) => {
        const haystack = searchTextFor(group, setting);
        return terms.every((term) => haystack.includes(term));
      }),
    }))
    .filter((group) => group.settings.length > 0);
};
